import { Wrench, Clock } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/Card';

const Maintenance = () => {
  return (
    <div className="min-h-screen bg-[var(--ds-canvas-bg)] flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center">
        <Card className="rounded-[var(--ds-radius-xl)] shadow-[var(--ds-shadow-popover)]">
          <CardContent className="p-8 md:p-12">
            {/* Icon */}
            <div className="flex justify-center mb-6">
              <div className="relative">
                <div className="absolute inset-0 bg-[var(--ds-accent-primary)] rounded-full opacity-20 animate-pulse"></div>
                <div className="relative bg-[var(--ds-accent-primary)] rounded-full p-6">
                  <Wrench className="h-12 w-12 text-white" />
                </div>
              </div>
            </div>

            {/* Title */}
            <h1 className="text-display md:text-4xl font-bold text-[var(--ds-text-primary)] mb-4">
              We'll Be Back Soon
            </h1>

            {/* Subtitle */}
            <p className="text-h1 text-[var(--ds-text-secondary)] mb-8">
              We're currently performing scheduled maintenance
            </p>

            {/* Description */}
            <Card className="bg-[var(--ds-control-field-bg)] mb-8">
              <CardContent className="p-6">
                <div className="flex items-start justify-center gap-3">
                  <Clock className="h-5 w-5 text-[var(--ds-accent-primary)] mt-0.5 flex-shrink-0" />
                  <p className="text-body text-[var(--ds-text-secondary)] text-left">
                    Our portal is temporarily unavailable while we make improvements. 
                    We expect to be back online shortly. Thank you for your patience.
                  </p>
                </div>
              </CardContent>
            </Card>

            {/* Additional Info */}
            <div className="text-meta text-[var(--ds-text-muted)]">
              <p>If you have urgent questions, please contact us directly.</p>
            </div>
          </CardContent>
        </Card>

        {/* Footer */}
        <p className="mt-8 text-meta text-[var(--ds-text-muted)]">
          SparxMate &copy; {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default Maintenance;

